import { SIGNIN_REQUEST, SIGNIN_REQUEST_ERROR, SIGNIN_REQUEST_SUCCESS } from "../actionType/type";

const initialState = {
    data: null,
    isLoading: false,
};

export const signinReducers = (state=initialState,action) => {
    let object
    switch (action.type) {
        case SIGNIN_REQUEST:
            object = {
                ...state,
                isLoading: true,
              }
            break
        case SIGNIN_REQUEST_ERROR:
            object = {
                ...state,
                isLoading:false
            }
            break
        case SIGNIN_REQUEST_SUCCESS:
            object = {
                ...state,
                data:action.payload,
                isLoading:false
            }
            break
    
        default:
            object = state
            break
    }
    return object
}